export default {"src":"/_next/static/media/ag.9ab0009d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};